import { render } from "./DinhMucCoDinhVatTuTable.vue?vue&type=template&id=4a2ba133&ts=true"
import script from "./DinhMucCoDinhVatTuTable.vue?vue&type=script&lang=ts"
export * from "./DinhMucCoDinhVatTuTable.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__